module.exports = __webpack_public_path__ + "img/background-01.a431f81b.png";